export default __webpack_public_path__ + "static/image0-deb8e3d0f822aa253050a10467161539.webp";